export const TYPE_VIEW = 'view'
export const TYPE_ACTION = 'action'

const buildEvent = (event) => {
  if (!event || !event.params) {
    return {
      event: TYPE_ACTION,
    }
  }

  const {
    seccion1,
    seccion2,
    seccion3,
    tipologia,
    subtipologia,
    productosContratados,
    tipoOperativa,
    accionEvento,
    etiquetaEvento,
    screen_name,
    edadDesplegable,
    urlPage,
    IDEvento,
  } = event.params

  return {
    event: accionEvento || 'virtualPage',
    page: screen_name || event.screen_name,
    seccion_s1: seccion1,
    seccion_s2: seccion2,
    seccion_s3: seccion3,
    tipologia,
    subtipologia,
    productosContratados,
    tipoOperativa,
    accionEvento,
    etiquetaEvento,
    edadDesplegable,
    url_page: urlPage,
    IDEvento,
  }
}

export const sendEvent = (tealium, event) => {
  switch (event ? event.type : TYPE_ACTION) {
    case TYPE_ACTION:
      tealium.link(buildEvent(event))
      break
    default:
      tealium.view(buildEvent(event))
      break
  }
}
